import { render } from "./adminTutorial.vue?vue&type=template&id=5a6c6876&scoped=true"
import script from "./adminTutorial.vue?vue&type=script&lang=js"
export * from "./adminTutorial.vue?vue&type=script&lang=js"

import "./adminTutorial.vue?vue&type=style&index=0&id=5a6c6876&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6c6876"]])

export default __exports__